module.exports = __webpack_public_path__ + "static/media/electoral-map.d4895c47.jpg";